module.exports = __webpack_public_path__ + "img/logo_eng.12275190.svg";